import React from 'react';
import './App.scss';
import Index from './pages/Index/Index';

function App() {
  return (
    <div className="App">
      <Index />
    </div>
  );
}

export default App;
